import React from 'react';
import { Card, CardContent } from '@roger/ui-components';
import { LucideIcon } from 'lucide-react';

interface StatCardProps {
  Icon: LucideIcon;
  value: string | number | React.ReactNode;
  label: string;
}

export const StatCard: React.FC<StatCardProps> = ({ Icon, value, label }) => {
  return (
    <Card>
      <CardContent className='p-6'>
        <div className='flex items-center gap-4'>
          <div className='p-3 bg-primary/10 rounded-lg'>
            <Icon className='h-6 w-6 text-primary' />
          </div>
          <div className='flex-1'>
            <div className='text-3xl font-bold'>{value}</div>
            <div className='text-sm text-muted-foreground mt-1'>{label}</div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
